import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: theme.spacings.sm,
  },
  logoWrapper: {
    width: theme.spacings['2xl'],
    height: theme.spacings.xl,
    marginBottom: theme.spacings.sm,
  },
  logo: {
    width: '100%',
    height: '100%',
  },
  linkRow: {
    flexDirection: 'row',
    columnGap: theme.spacings.xl,
  },
  linkText: {
    fontSize: theme.fontSizes.xl,
  },
});
